import { type ReactNode, useMemo } from "react";

import { useAuth } from "@/auth/use-auth";
import { env } from "@/lib/env";

import { createApiClient } from "./client";
import { ApiClientContext } from "./client-context";

export function ApiClientProvider({ children }: { children: ReactNode }) {
  const { getAuthHeaders, onUnauthorized } = useAuth();

  const client = useMemo(
    () =>
      createApiClient({
        basePath: env.apiBasePath,
        getAuthHeaders,
        onUnauthorized,
      }),
    [getAuthHeaders, onUnauthorized],
  );

  return (
    <ApiClientContext.Provider value={client}>
      {children}
    </ApiClientContext.Provider>
  );
}
